import { defineComponent as _defineComponent } from 'vue'
import { HatchStyle, PlantVariety } from 'farmdok-rest-api';


export default /*#__PURE__*/_defineComponent({
  __name: 'MapHatchHorizontal',
  props: {
    variety: null
  },
  setup(__props: any) {



return { __sfc: true,HatchStyle }
}

})